import { render, staticRenderFns } from "./BaseDateInput.vue?vue&type=template&id=4fe864ce"
import script from "./BaseDateInput.vue?vue&type=script&lang=js"
export * from "./BaseDateInput.vue?vue&type=script&lang=js"
import style0 from "./BaseDateInput.vue?vue&type=style&index=0&id=4fe864ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports